import React from "react";
import { Button, Container, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";

const LockScreen = () => {
  const navigate= useNavigate()
  return (
    <div>
      <Container className="d-flex align-items-center justify-content-center vh-100 ">
        <Card className="p-4 text-center" style={{ width: "24rem" }}>
          <h2 className="mt-3">Account Blocked</h2>
          <p className="text-muted">
            Your account has been blocked. Please contact support for
            assistance.
          </p>
          <div className="mt-4 d-grid gap-2">
            <Button variant="primary">
              Contact Support
            </Button>
            <Button variant="secondary" onClick={()=>navigate("/")}>Back To Login</Button>
          </div>
        </Card>
      </Container>
    </div>
  );
};

export default LockScreen;
